import {
  checkNull,
  KeyValPair,
  ListContent,
  ReportContainer,
} from "../constant";

interface PhysicalExamBlockProps {
  data: any;
}

const PhysicalExamBlock = ({ data }: PhysicalExamBlockProps) => {
  if (!checkNull(data?.physicalTemplates)) return null;

  return (
    <ReportContainer label="Physical Exam">
      <ListContent
        list={data?.physicalTemplates}
        renderItem={(item) =>
          item?.description && (
            <KeyValPair
              k={item?.templateNameType}
              v={item?.description || ""}
            />
          )
        }
      />
    </ReportContainer>
  );
};

export default PhysicalExamBlock;
